import React from 'react';
import CustomTable from '../../components/CustomTable';
import TextField from '@material-ui/core/TextField';
import {globales, colores, funciones} from '../../global';
import AuthService            from '../../AuthService';
import {withStyles} from '@material-ui/core/styles';
import Select from '../../components/Select';
import Request from 'superagent';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
//import ListSubheader from '@material-ui/core/ListSubheader';
import Paper from '@material-ui/core/Paper';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import {TableHeaderRow} from '@devexpress/dx-react-grid-material-ui';
import {DataTypeProvider, IntegratedFiltering} from '@devexpress/dx-react-grid';
import Tooltip from '@material-ui/core/Tooltip';
import SchoolIcon from '@material-ui/icons/School';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import { Pie, Chart, Line } from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import TimelineIcon from '@material-ui/icons/Timeline';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import DialogContent from '@material-ui/core/DialogContent';
import {virtual} from '../../components/VirtualListBox';
import Backdrop from '@material-ui/core/Backdrop';
import InfoIcon from '@material-ui/icons/Info';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Fade from '@material-ui/core/Fade';
//import { Divider } from '@material-ui/core';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let colorRep = '#CB4335';
let colorEqu = '#886F0B';
let colorRet = '#7D3C98';
let colorCur = '#229954';
let colorAus = '#D35400';
let colorProped = '#0e4682';
let planes = [];

const styles = theme => ({
container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: "center",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1)
},
textField: {
  marginRight: !movil ? theme.spacing(1) : undefined,        
},
formControlSelect: {
  width: movil ? '100%' : '430px', 
  marginLeft: !movil ? theme.spacing(1) : undefined, 
  textAlign: 'left',
},
paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '420px' : undefined,
  maxWidth: !movil ? '420px' : undefined,
  height: !movil ? '620px' : undefined,
  maxHeight: !movil ? '95%' : undefined,
},
paperDetail: { 
  borderRadius: globales.border_dialog,
  minHeight: !movil ? '490px' : undefined,
  maxHeight: !movil ? '490px' : undefined,
  minWidth: !movil ? '717px' : undefined,
  maxWidth: !movil ? '717px' : undefined,
},
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
small: {
  width: theme.spacing(3),
  height: theme.spacing(3),
  marginLeft: '30px',
  fontSize: '12px'
},
divDetailLoading: {
  width: '100%', 
  height: '100%',  
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center'
},
divDetail:{
  width: '100%', 
  height: '100%',
},
customCellBold: {
  color: colores.azul,
  fontWeight: 'bold'
},
tooltip: {
  maxWidth: !movil ? 'none' : undefined,
},
divInfo: {
paddingBottom: '0px', 
marginBottom:'0px', 
marginTop: "0px", 
paddingLeft: '10px', 
paddingRight: '10px', 
marginLeft: '8px', 
marginRight: '8px',
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},

});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns=[  
                { name: 'ICON', title: 'ICON'},
                { name: 'ANIO', title: 'Año'},
                { name: 'PERIODO', title: 'Período'},
                { name: 'CODIGO_CURSO', title: 'Código'},
                { name: 'DESCRIPCION_CURSO', title: 'Descripción'},
                { name: 'CREDITOS', title: 'Uv'},                                      
                { name: 'NOTA', title: 'Nota'},
                { name: 'ESTATUS', title: 'Estado'},
                { name: 'ID_SECCION_CLIENTE', title: 'ID_SECCION_CLIENTE'},
                { name: 'DIAS', title: 'Dias'  },
                { name: 'INICIO', title: 'Desde'},
                { name: 'FIN', title: 'Hasta'},
                { name: 'CATEDRATICO', title: 'Catedrático' },
                { name: 'ETIQUETA', title: 'ETIQUETA'}
              ];
const columnExtensions = [
      { columnName: 'ICON', width: 1},
      { columnName: 'CODIGO_CURSO', width: widthTable * 0.09},
      { columnName: 'DESCRIPCION_CURSO', width: widthTable * 0.22 }, 
      { columnName: 'CREDITOS', width: widthTable * 0.06, align: 'center'},
      { columnName: 'NOTA', width: widthTable * 0.06, align: 'center'},
      { columnName: 'ESTATUS', width: widthTable * 0.08, align: 'center'}, 
      { columnName: 'DIAS', width: widthTable * 0.07, align: 'center'},
      { columnName: 'INICIO', width: widthTable * 0.08, align: 'center'},
      { columnName: 'FIN', width: widthTable * 0.08, align: 'center'},
      { columnName: 'CATEDRATICO', width: widthTable * 0.15, },   
      { columnName: 'ID_SECCION_CLIENTE', width: 0},
      { columnName: 'ETIQUETA', width: 0}, 
      { columnName: 'ANIO', width: 0},
      { columnName: 'PERIODO', width: 0},  
];
const grouping = [{ columnName: 'ANIO' }, { columnName: 'PERIODO' }];

const columnsInfo = [ { name: 'LABEL', title: ' ' },
                      { name: 'VALUE', title: '  ' },
                    ];
const columnExtensionsInfo = [
                      { columnName: 'LABEL', width: movil ? 145 : 180},          
                    ];

const settingFilter = [{ columnName: 'INICIO',
                          predicate: (value, filter, row) => {
                                      value = value !== null ? funciones.getTime(value, 1) : value; 
                                      return IntegratedFiltering.defaultPredicate(value, filter, row);
                                    },
                        },   
                        { columnName: 'FIN',
                          predicate: (value, filter, row) => {
                                      value = value !== null ? funciones.getTime(value, 1) : value; 
                                      return IntegratedFiltering.defaultPredicate(value, filter, row);
                                    },
                        },                     
                     ];

const RowId = row => row.ID_SECCION_CLIENTE;
const VirtualTable_cellComponent = (props) => {
  
const {row} = props; 
const colorFont =  row.ESTATUS_ACADEMICO === '' ? colorCur :  
                   row.ESTATUS_ACADEMICO === 'R' ? colorRep : 
                   row.ESTATUS_ACADEMICO === 'E' ? colorRet :
                   row.ESTATUS_ACADEMICO === 'C' ? colorEqu :
                   row.ESTATUS_ACADEMICO === 'N' ? colorAus :
                   row.ESTATUS_ACADEMICO === 'S' ? colorEqu :
                   row.ESTATUS_ACADEMICO === 'P' ? colorProped :
                   undefined;
                   

return (<Table.Cell style={{ color: colorFont }} {...props} />);
    
}  
const VirtualTable_cellComponentInfo= (classes)=>({value, ...props}) => {
      
 const {column, row} = props;
 const promType = row.LABEL.toLowerCase().includes("his") ? 2 : 1;
 const border = promType === 2 ? "none" : undefined;
 
 if (column.name === 'VALUE' && row.LABEL.toLowerCase().includes("promedio"))
 {
   return (<Table.Cell style={{ paddingTop: "5px", paddingBottom: "5px", height: "30px", display: "flex", alignItems: "center", border: border }} {...props}>
           <span>{value}</ span>
            <Tooltip title={promType === 1 ? "El promedio de graduación comprende solo los cursos del plan aprobados en la institución" : 
                                             "El promedio histórico comprende todos los cursos del plan inscritos en la institución"} 
                     PopperProps={{style:{zIndex:500000}}}
                     placement={!movil ? "right" : "top"}
                     arrow>
              <InfoIcon style={{ marginLeft: "16px", color: colores.tabla.color_iconos_SL }}/>
            </ Tooltip>
           </ Table.Cell>);
 }

 return (<Table.Cell className={column.name === 'LABEL' ? classes.customCellBold : undefined} 
                     style={{ paddingLeft: column.name === 'LABEL' ? movil ? '2px' : '25px' : undefined, border: border }} 
                     value={value}
                     {...props}
                    />);    
    
}

const GroupCellContent = ({ column, row }) => (
    <span>    
      <strong> {row.value.search('Equivalencias') === '0' ? 'Equivalencias' : parseInt(row.value) <= 100 ? 'Período ' + row.value : row.value  } </strong> 
    </span>
);

const StubCellComponentTable = (idRowSelected, handleRowDetailsClick) => ({colSpan, ...props}) => {

if (props.tableRow.type.toString() === 'Symbol(data)' && props.tableColumn.column !== undefined && props.tableColumn.column.name === 'PERIODO' && props.tableRow.row.ID_SECCION_CLIENTE === idRowSelected 
    && props.tableRow.row.ESTATUS_ACADEMICO !== 'C' && props.tableRow.row.ESTATUS_ACADEMICO !== 'E' && props.tableRow.row.ESTATUS_ACADEMICO !== 'S' && props.tableRow.row.ESTATUS_ACADEMICO !== 'P') 
{
  return (<Table.StubCell style={{ textAlign: "center" }} {...props}>
          <Tooltip title="Calificaciones" >
            <IconButton onClick={handleRowDetailsClick} size="small">
              <TimelineIcon style={{ color: colores.azul }} /> 
            </IconButton>                 
          </Tooltip>
        </ Table.StubCell>         
        );
}

if (props.tableRow.type.toString() === 'Symbol(data)' && props.tableColumn.column !== undefined && props.tableColumn.column.name === 'ANIO' && props.tableRow.row.ETIQUETA !== null)
{
  return (<Table.StubCell style={{ textAlign: "center" }} {...props}>
            <Tooltip title={props.tableRow.row.ETIQUETA} size="small">
              <LabelImportantIcon style={{ color: colores.tabla.color_iconos_SL, cursor: 'default' }} />
            </Tooltip>
          </Table.StubCell>
        );
}

return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props} />);

}
const ColumnHeader_cellComponent = (Icon, ToolTipText, handleClickInfo) => ({resizingEnabled, ...props}) => {
       
  const {column} = props;
                 
  if (column.name === 'ICON')
   {    
       return (<TableHeaderRow.Cell style={{ paddingTop: 0, paddingBottom: 0 }} resizingEnabled={false} {...props} >
                  <Tooltip title={ToolTipText !== undefined ? ToolTipText : '< No hay plan seleccionado >'} >
                  <IconButton onClick={handleClickInfo} style ={{ left: -100, }} size="small">

                  {
                    (() => {

                      return (
                        Icon
                      );

                    })()

                 }

                  </IconButton>                 
                 </Tooltip>
               </TableHeaderRow.Cell>
              );
    }
    
   return (<TableHeaderRow.Cell resizingEnabled={resizingEnabled} {...props} />);
    
}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);
const DateFormatter = ({ value }) => (value != null) ? funciones.getTime(value, 1) : value;                                      
const DataTypeProviders = (<DataTypeProvider
                             for={['INICIO', 'FIN']}
                             formatterComponent= {DateFormatter}               
                            />);

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
tablaInfoRef = React.createRef();
planesRef = React.createRef();
rowRef = React.createRef();
tablaDetailRef = React.createRef();
dialogAction2Ref = React.createRef();
dialogRef = React.createRef();

  constructor (props) {
    super(props);
    this.state = {       
       isLoggin : undefined,
       heightTableMain: 0,     
       datosSelectPlan : null,
       selectedPlan: '',
       rows: [],
       expandedGroups: [],
       loadingMain: false,
       idRowSelected: null,
       openModalInfo: false,
       chartData: {},
       chartOptions:{},
       rowsInfo: [],       
       totalCumplidas: -1,
       openModalDetail: false,
       rowsDetail: [],
       tableDetailHeight: 0,
       lessIdExtra: -1,
       valueAutoComplete: null,
       loadingClientes: true,
       openAutoComplete: false,
       optionAutocomplete: [],
       chartDetailData: {},
       chartDetailOptions: {
                            legend: { display: false},
                             scales: { yAxes: [{
                                                display: true,
                                                ticks: {
                                                    beginAtZero: true,
                                                    steps: 10,
                                                    stepValue: 10, //5,
                                                    max: 105,
                                                    callback: function (value) {                                                
                                                      return value === 105 ? null : value;
                                                     }                                               
                                                },                                                                                                                                              
                                            }]
                                            
                                          },
                              layout: { 
                                padding: {
                                  top: !movil ? 15 : 20
                                 },
                              },
                              tooltips: {
                                callbacks: {
                                  label: function (tooltipItems){                                 
                                    return 'Promedio en el parcial: ' + tooltipItems.value.toString() + '%';
                                  }
                                }
                              }
                           },
       loadingDetail: false,
       titleDetail: '',
       loadingInfo: false,
       loadingPlanes: false,
   };
  this.cuenta = null;
}

drawInnerText = (chart) => {
  
    var width = chart.chart.width,
        height = chart.chart.height,
        ctx = chart.chart.ctx;

    ctx.restore();
    var fontSize = 1.8; 
    ctx.font = fontSize + "em sans-serif";
    ctx.textBaseline = "middle";

    var text = chart.config.options.centerText.text,
        textX = Math.round((width - ctx.measureText(text).width) / 2), 
        textY = (height / 2) - 5; 
    
    ctx.fillStyle = colores.naranja;
    ctx.fillText(text, textX, textY);
    ctx.save();
}

drawLabelsPoints = (chart) =>{

if (this.state.rowsDetail.length === 0) {return; } 

let indexDataset;

Object.keys(chart.config.data.datasets[0]._meta).map((item)=>{
  indexDataset = item;
  return item;
});

var ctx = chart.chart.ctx;

let dataset = chart.config.data.datasets[0]._meta[indexDataset].data; 
let _this =this;
let labelDraw =  '';
let totalPoints = chart.config.data.datasets[0]._meta[indexDataset].data.length;

dataset.forEach(function (points, index) { 
  labelDraw =  '';
  if (_this.state.rowsDetail[index].FECHA_APLICO_NOTA !== null || _this.state.rowsDetail.find(x => x.ID_PONDERACION === 100).VALOR !== null || _this.state.rowsDetail[index].VALOR > 0 || (_this.state.rowsDetail[index].VALOR === 0 && _this.state.rowsDetail[index].ID_PONDERACION!==99))
  {
     labelDraw = _this.state.rowsDetail[index].VALOR + ' | ' + _this.state.rowsDetail[index].PORCENTAJE; 
  }

  if (_this.state.lessIdExtra === _this.state.rowsDetail[index].ID_CALIFICACION)
  {
    ctx.fillStyle = 'red';    
    ctx.fillRect(points._view.x - 8, points._view.y - 27, 48, 20);
    ctx.fillStyle = 'white';
  }
  else
  {
    ctx.fillStyle = 'black';
  }

  ctx.textAlign = "center";
  ctx.textBaseline = "bottom";
  ctx.fillText(labelDraw, index === 0 ? points._view.x + 22 : index === totalPoints - 1 ? points._view.x + 5 : points._view.x + 15, points._view.y - 10);
  
  ctx.save(); 
      
});



}

selectionPlanEstudio = (arrayPlanes) => {
   
  if (arrayPlanes.length === 0){
      
    return  '';

  } 

  if (arrayPlanes.length === 1){
      
    return  arrayPlanes[0].ID_PLAN;

  } 
  
  let select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='ACTIVO');

  if (select !== null && select.length > 0)
  {   
      return select[0].ID_PLAN;
  }


  select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='EGRESADO');

  if (select !== null && select.length > 0)
  {
      return select[0].ID_PLAN;
  }


  select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='GRADUADO');

  if (select !== null && select.length > 0)
  {
      return select[0].ID_PLAN;
  }
  
  return '';
   

}

handleChangeCuenta = (event) => {
    
  this.cuenta = (event === null && tokenInfo.plataforma === 2) ? tokenInfo.user : tokenInfo.plataforma === 1 ? this.state.valueAutoComplete.CUENTA_ALUMNO : null;
  this.setState({ loadingPlanes: true }, ()=>{ 

  new Request
  .get(`${globales.ip}/historial/planes/${this.cuenta}/${tokenInfo.plataforma}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
              
    if (err) { 
        
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
                    
        window.location.reload();
        return;
                      
      }
              
      planes = [];
      this.setState({ selectedPlan: '', datosSelectPlan: null, rows: [],  idRowSelected: null, loadingPlanes: false }, ()=>{  
        funciones.showToast('e', 'No hay conexión');
      });
                          
      return;
    }
              
   planes = JSON.parse(res.text);
   let niveles = [];
   let datosSelect = [];
        
   if (planes.length > 0) 
   {    
      planes.map((item, i) =>{

        if (!niveles.find(x => x === item.ID_NIVEL))
        {
          niveles.push(item.ID_NIVEL);

          if (!datosSelect.find(x => x.label === item.DESCRIPCION_NIVEL.trim())){
           datosSelect.push({value: item.ID_NIVEL * -1, label: item.DESCRIPCION_NIVEL.trim() })
          }

          planes.map((itemx, j) =>{ 
            if (itemx.ID_NIVEL === item.ID_NIVEL)
             datosSelect.push({value: itemx.ID_PLAN, label: itemx.DESCRIPCION_PLAN ,estado: itemx.ESTADO})
          
            return item;
          });                             
                           
        }
                  
        return item;

      });

      let datosSelect_ = datosSelect.map((item, i) =>{
        if (item.value < 0)
          return (
          <div   style={{paddingLeft: 5,paddingRight: 10,paddingBottom: 0,marginBottom:0,color:'#BFBFBF',fontSize: '11px'}}  value='' key={i}  >
            {item.label}
          </div>
          ); 
        else
          return (<MenuItem value={item.value} key={i} >{item.estado==='ACTIVO'?<b>{item.label}- Activo</b>:item.label}</MenuItem>);
       });
                
        this.setState({ datosSelectPlan: datosSelect_, selectedPlan: this.selectionPlanEstudio(planes), loadingPlanes: false });
        this.handleChangePlan('auto');
      }              
      else
      { 
        planes = [];
        this.setState({ selectedPlan: '', datosSelectPlan: null, rows: [],  idRowSelected: null, loadingPlanes: false });     
      }
           

  });    

});

}

obtenerHistorial = (cuenta, id_plan) => {
  
this.setState({ loadingMain: true }, ()=>{ 

  new Request
  .get(`${globales.ip}/historial/informacion/${cuenta}/${id_plan}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
        
        this.setState({ rows: [], expandedGroups: [], loadingMain: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
            
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0)
     {    

      let allGroups = [];
      let foundAnio;
      let foundPeriodo; 

      rows.map((item, i) => {

        foundAnio = allGroups.find(anio => anio === item.ANIO);
        
        if (foundAnio === undefined && item.ANIO !== "0")
           allGroups.push(item.ANIO);
        else
          foundAnio = undefined;

        foundPeriodo= allGroups.find(periodo => periodo === item.ANIO + '|' + item.PERIODO);

        if (foundPeriodo === undefined && item.ANIO !== "0")
         allGroups.push(item.ANIO + '|' + item.PERIODO);
        else 
          foundPeriodo = undefined;
        
        return item;
      });     

      this.setState({ rows: rows, expandedGroups: allGroups, loadingMain: false });
     }
     else
       this.setState({ rows: [], expandedGroups: [], loadingMain: false });
     
 });

});

}

obtenerTotalCumplidas = (cuenta, id_plan) =>
{
  
  new Request
  .get(`${globales.ip}/historial/total_cumplidos/${cuenta}/${id_plan}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
    if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
        
        this.setState({ totalCumplidas: 0 }, ()=>{ 
          funciones.showToast('e', 'No hay conexión'); 
        });
    
        return;
    }
        
    const rows = JSON.parse(res.text);
  
    if (rows.length > 0)
     this.setState({ totalCumplidas: rows[0].TOTAL_CUMPLIDAS });               
    
  });
}

obtenerPromedios = (cuenta, id_plan) =>{
  
  new Request
  .get(`${globales.ip}/historial/promedios/${cuenta}/${id_plan}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 20000, deadline: 15000, }) 
  .end((err, res) => {
                  
    if (err) { 
          
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
                      
         window.location.reload();
         return;
                        
     }
          
     this.setState({ rowsInfo: [], loadingInfo: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
     }); 
            
      return;

     }
                
   const rows = JSON.parse(res.text);
          
   if (rows.length > 0)
   {    
    
    const rowsInfo = [
      { LABEL: 'Código de plan', VALUE: planes.find(x => x.ID_PLAN === this.state.selectedPlan).CODIGO_PLAN },
      { LABEL: 'Descripción de plan', VALUE: planes.find(x => x.ID_PLAN === this.state.selectedPlan).DESCRIPCION_PLAN },
      { LABEL: 'Estado de plan', VALUE: planes.find(x => x.ID_PLAN === this.state.selectedPlan).ESTADO + ' (' + this.state.totalCumplidas + ' de ' +  planes.find(x => x.ID_PLAN === this.state.selectedPlan).TOTAL_CURSOS_PLAN + ' cursos)' },
      { LABEL: 'Promedio graduación', VALUE: rows[0].PROMEDIO_GRADUACION < 100 ? rows[0].PROMEDIO_GRADUACION.toFixed(2) + '%' : rows[0].PROMEDIO_GRADUACION + '%' }, 
      { LABEL: 'Promedio histórico', VALUE: rows[0].PROMEDIO_HISTORICO < 100 ? rows[0].PROMEDIO_HISTORICO.toFixed(2) + '%' : rows[0].PROMEDIO_HISTORICO + '%'}, 
    ];
    
    this.setState({ rowsInfo, loadingInfo: false }); 
    
   }
   else
    this.setState({ rowsInfo: [], loadingInfo: false });
   
 });

}

handleChangePlan = async (event) => {

if (event !== 'auto' && this.state.selectedPlan === event.target.value)
  return;

  
if (event === 'auto' || event.target.value > 0 )
{  
  this.obtenerTotalCumplidas(this.cuenta, event === 'auto' ? this.state.selectedPlan : event.target.value  );    
  await Promise.resolve(this.setState({ totalCumplidas: -1, selectedPlan: event === 'auto' ? this.state.selectedPlan : event.target.value, rowsInfo: [] })); 
  this.obtenerHistorial(this.cuenta, event === 'auto' ? this.state.selectedPlan : event.target.value );
}
  
}

changeExpandedGroups = expandedGroups =>
{
  this.setState({ expandedGroups });  
}

handleCloseInfo = () => {

this.setState({ openModalInfo: false });

}

onEnteringInfo = () => {
  
 let recorrido = this.state.rows.length > 0 ? this.state.totalCumplidas * 100 /  planes.find(x => x.ID_PLAN === this.state.selectedPlan).TOTAL_CURSOS_PLAN : 0;

  let chartData = {

    labels : ['Cursado', 'Restante'],
    datasets: [ { data: [recorrido , 100 - recorrido ], 
                  backgroundColor: [ colores.azul, 'white' ], 
                  hoverBackgroundColor: [colores.azul, 'white'],
                  hoverBorderColor: [colores.azul,'#E5E7E9'],
                  borderColor: recorrido < 100 ? [colores.azul,'#E5E7E9'] : colores.azul,                 
                }, 
              ],
   };
   
   let chartOptions = {

    maintainAspectRatio: true, 
    legend: { position: 'bottom', fullWidth: false, onClick: null }, 
    plugins: {
                 labels: {  
                   render: (args) => { 
                                       return '';
                                     },
                   precision: 2,
                   fontColor: colores.naranja,
                   fontSize: 25,
                   showZero: true,                 
                 },
             },
   tooltips: {  enabled: false },
   title: {
     display: true,
     text: 'Porcentaje completado de carrera',
    },
    centerText: {
     display: true,
     text: recorrido < 100 ? recorrido.toFixed(2) + '%' : recorrido + '%',            
    },           
   animation: { 
                easing: 'easeOutExpo' //'linear' 
              },

   }
     
   this.setState({ chartData: chartData, chartOptions: chartOptions });
                 
}

handleCloseDetail = () => {
  
  this.setState({ openModalDetail: false, rowsDetail: [], chartDetailData: {}, });
  
}

onEnteringDetail = () => {
   
  new Request
  .get(`${globales.ip}/historial/calificaciones/${this.state.idRowSelected}/${this.cuenta}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
          
          window.location.reload();
          return;
                
        }
                
        this.setState({ openModalDetail: false, rowsDetail: [], chartDetailData: {}, loadingDetail: false }, ()=>{
          funciones.showToast('e', 'No hay conexión');          
        });      
    
        return;
     }
     
     const rows = JSON.parse(res.text); 
  
     if (rows.length > 0)  
     {    
          let extraValue = rows.find(x => x.ID_PONDERACION === 99);
          let lessIdExtra = [];
          let availableExtra =[];
          
         if (extraValue !== null && extraValue !== undefined && (extraValue.VALOR > 0 || rows[0].EXTRAORDINARIO))
         {
            
            availableExtra = rows.filter(x => x.PERMITE_EXTRAORDINARIO === 1);

            if (availableExtra.length === 0)
            {
              lessIdExtra.push({ ID_CALIFICACION: rows.find(x => x.ID_PONDERACION === 99).ID_CALIFICACION, VALOR: rows.find(x => x.ID_PONDERACION === 99).VALOR });
            }

            availableExtra.map((item, index)=> {

                  if (index === 0)
                  {
                      lessIdExtra = [];
                      lessIdExtra.push({ ID_CALIFICACION: item.ID_CALIFICACION, VALOR: item.VALOR });
                  }
                  else
                  {
                        if (item.VALOR < lessIdExtra[0].VALOR)
                        {
                            lessIdExtra = [];
                            lessIdExtra.push({ ID_CALIFICACION: item.ID_CALIFICACION, VALOR: item.VALOR });
                        }
                  }

                return item;
            });

         }
         else
         {   
            if (extraValue !== undefined)
            {
              lessIdExtra.push({ ID_CALIFICACION: rows.find(x => x.ID_PONDERACION === 99).ID_CALIFICACION, VALOR: rows.find(x => x.ID_PONDERACION === 99).VALOR });
            }
         }
         
         let labelChart = []; 
         let dataChart = []; 
         rows.map((item)=>{

          if ((item.ID_PONDERACION !== 100 && item.ID_PONDERACION !== 99 && item.PORCENTAJE > 0) || (item.ID_PONDERACION === 99 && item.ID_CALIFICACION !== lessIdExtra[0].ID_CALIFICACION))
          {
            labelChart.push(item.PONDERACION);
            dataChart.push(parseFloat(item.VALOR*100/item.PORCENTAJE).toFixed(2) > 100 ? 100 : parseFloat(item.VALOR*100/item.PORCENTAJE).toFixed(2));
          }
          return item;
         });
         
         dataChart = {  
          labels: labelChart,
          datasets: [
           {
             label: 'Valor porcentual',
             fill: true,
             lineTension: 0.1,
             backgroundColor: 'rgba(' + colores.azul_rgb + ', 0.6)', 
             borderColor: 'rgba(' + colores.azul_rgb + ', 1)',
             borderCapStyle: 'butt',
             borderDash: [],
             borderDashOffset: 0.0,
             borderJoinStyle: 'miter',
             pointBorderColor: 'rgba(' + colores.azul_rgb + ', 1)',
             pointBackgroundColor: '#fff',
             pointBorderWidth: 1,
             pointHoverRadius: 5,
             pointHoverBackgroundColor: 'rgba(75,192,192,1)',
             pointHoverBorderColor: 'rgba(220,220,220,1)',
             pointHoverBorderWidth: 3,
             pointRadius: 5,
             pointHitRadius: 10,
             data: dataChart
           }
         ]
        }
         
         this.setState({ lessIdExtra: lessIdExtra[0] !== undefined ? lessIdExtra[0].ID_CALIFICACION : -1, rowsDetail: rows, chartDetailData: dataChart, loadingDetail: false });  
     }         
   
  });


}

onChangeAutocomplete = (event, value) =>{
  
  planes = [];
  this.setState({ valueAutoComplete: value, 
                  openAutoComplete: false, 
                  selectedPlan: '', 
                  datosSelectPlan: null, 
                  rows: [], 
                  idRowSelected: null,
                  rowsInfo: [] }, ()=>{
    
    if (value === null)
     return;
    
    this.handleChangeCuenta(null);   
    
  });
 

}

filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/historial/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 20000, deadline: 30000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
}

handleRowDetailsClick = event => {
          
event.preventDefault();
const title = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.state.idRowSelected).DESCRIPCION_CURSO.split('(')[0].trim();

this.setState({ loadingDetail: true, 
                titleDetail: title, 
                openModalDetail: true });
      
}

handleClickInfo = () => {
                       
if (funciones.isEmpty(this.state.selectedPlan)) { return; }
  
if (this.state.totalCumplidas < 0)
 return;
  
if (this.state.rowsInfo.length > 0){
  this.setState({ openModalInfo: true });
  return;
}

this.setState({ loadingInfo: true, openModalInfo: true }, ()=>{ 
  this.obtenerPromedios(this.cuenta, this.state.selectedPlan);
});                                  

}

handleRowClick = (IdSeccionCliente) => event => {
          
event.preventDefault();
this.setState({ idRowSelected: IdSeccionCliente });

  
}

onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}

componentDidMount() { 

 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{ 
  
  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
     this.filtersClientes("-");
  }
  else if (tokenInfo.plataforma === 2) //Usuario estudiante
  {    
    this.setState({ loadingClientes: false }); 
    this.handleChangeCuenta(null);        
  }

  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{
    if (!movil && tokenInfo.plataforma === 1) {
      document.getElementById("est_historial").focus();
      return;
    }

    if (!movil){
      this.planesRef.current.focus();
    }
  }); 

  let _this = this;      
  Chart.Chart.pluginService.register({
        afterDraw: function (chart) { 
           
          if (_this.state.openModalInfo)
          {
            if (chart.config.options.centerText.display !== null &&
                typeof chart.config.options.centerText.display !== 'undefined' &&
                chart.config.options.centerText.display) {
                _this.drawInnerText(chart);
            }
          }
          
        },
        afterDatasetsDraw: function (chart) { 
          if (_this.state.openModalDetail){ 
            _this.drawLabelsPoints(chart);
          }
        }
    });
  
  });

}

render() {
const { classes } = this.props; 

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
       <Paper className="Paper-main" square>
          {
            (() => {

            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment >                  
                 <div className={classes.container}>        
                  <Autocomplete
                    id="est_historial"
                    options={this.state.optionAutocomplete}
                    getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                    style={{ width: movil ? '100%' : '430px' }}
                    renderInput={(params) => <TextField {...params} 
                                                        label="Estudiante"
                                                        variant="outlined"                                                             
                                                        onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                        InputProps={{
                                                              ...params.InputProps,
                                                               endAdornment: (
                                                                <React.Fragment>
                                                                  {this.state.loadingClientes ? 
                                                                   <Fade in style={{
                                                                    transitionDelay: '1000ms',
                                                                  }} unmountOnExit>
                                                                   <CircularProgress size={18} /> 
                                                                   </Fade>
                                                                   : null}
                                                                  {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                              ),
                                                            }}
                                                            fullWidth                                                            
                                                            />}
                    renderOption={RenderOption}                                 
                    onChange={this.onChangeAutocomplete}
                    open={this.state.openAutoComplete}
                    loading={this.state.loadingClientes}
                    ListboxComponent={virtual.ListboxComponent}
                    value={this.state.valueAutoComplete} 
                    className={classes.textField}
                    disableClearable={this.state.loadingMain}
                    onInputChange={this.onChangeInput}
                    popupIcon={null}    
                    PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                           
                    /> 
                    <Select Label='Plan de estudio'
                            Datos = {this.state.datosSelectPlan} 
                            Selected= {this.state.selectedPlan}
                            onChange={this.handleChangePlan}
                            Style = {classes.formControlSelect}                                 
                            Outlined                        
                            id='planes'                                  
                            Ref={this.planesRef}                            
                            />                             
                   </div>
                </React.Fragment>
              );

             }
             else if (tokenInfo.plataforma === 2) //Si es Usuario Estudiante
             {

              return (
                <React.Fragment >
                  <div  className={classes.container}>
                  <Select Label='Plan de estudio'
                          Datos = {this.state.datosSelectPlan} 
                          Selected= {this.state.selectedPlan}
                          onChange={this.handleChangePlan}
                          Style = {classes.formControlSelect}                                  
                          Outlined                              
                          id='planes'                                  
                          Ref={this.planesRef}                            
                          /> 
                  </div>
                </React.Fragment>
                  );

             }
                          
            })()

          }

          <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions"> 
            <CustomTable 
              Columns={columns}
              Rows={this.state.rows}
              Grouping={grouping} 
              TableColumnExtensions={columnExtensions} 
              columnWidths={columnExtensions}
              DefaultHiddenColumnNames={['ID_SECCION_CLIENTE', 'ETIQUETA']}
              VirtualTable_cellComponent={VirtualTable_cellComponent}
              ExpandedGroups={this.state.expandedGroups}
              ChangeExpandedGroups={this.changeExpandedGroups}                    
              getRowId={RowId}                    
              height={this.state.heightTableMain} 
              loading={this.state.loadingMain}  
              rowSelected={this.state.idRowSelected}
              rowClick={this.handleRowClick}
              DataTypeProviders={DataTypeProviders}
              enabledFilterRows
              rowHeaderCellComponent= {ColumnHeader_cellComponent(<SchoolIcon style={{ color: this.state.selectedPlan !== '' && this.state.totalCumplidas >= 0 ? colores.tabla.color_iconos : colores.tabla.color_iconos_SL  }} />, this.state.selectedPlan !== '' ? this.state.totalCumplidas >= 0 ? 'Estado de plan: ' + planes.find(x => x.ID_PLAN === this.state.selectedPlan ).ESTADO : 'cargando por favor espere...' : undefined, this.handleClickInfo)}
              groupContentComponent={GroupCellContent}
              stubCellComponentTable = {StubCellComponentTable(this.state.idRowSelected, this.handleRowDetailsClick)}                                    
              FilteringColumnExtensions = {settingFilter}
               />                  
              </div>

              <Dialog open= {this.state.openModalInfo}                            
                      TransitionProps={{ onEntering: this.onEnteringInfo }} 
                      classes = {{ paper: classes.paper }}
                      fullScreen = {movil}>
               <DialogTitle><Typography component='span' variant='subtitle1'><Box lineHeight={1} m={1}>{this.state.selectedPlan !== '' ? planes.find(x => x.ID_PLAN === this.state.selectedPlan ).DESCRIPCION_NIVEL : undefined} </Box></Typography>
                 <IconButton className={classes.closeButton}   onClick={this.handleCloseInfo} size="small">
                   <CloseIcon fontSize="small"/>
                 </IconButton>
               </DialogTitle>               
                 <Pie
                     data={this.state.chartData}
                     width={!movil ? 300 : 270}  
                     height={180}//{150}
                     options={this.state.chartOptions}                          
                     />
                 <div ref={this.tablaInfoRef} className={classes.divInfo} >
                 <br/>
                 <CustomTable 
                    Columns={columnsInfo} 
                    Rows={this.state.rowsInfo}                            
                    TableColumnExtensions={columnExtensionsInfo}
                    VirtualTable_cellComponent={VirtualTable_cellComponentInfo(classes)}                
                    height = {220}
                    disableHeader
                    disableBoxShadow 
                    loading={this.state.loadingInfo}
                    disabledAlternateRowColor
                    />                                           
                   </div>
                   <DialogActions style={{ marginTop: "auto" }}/>
                  </Dialog>
                                    
                  <Dialog open= {this.state.openModalDetail}                            
                          TransitionProps={{ onEntering: this.onEnteringDetail }} 
                          classes = {{ paper: classes.paperDetail }}
                          fullScreen = {movil}                 
                          PaperProps={{ ref: this.dialogRef }}
                      >
                      <DialogTitle className="disableTouchOptions"><Typography component='span' variant='subtitle1'><Box lineHeight={1} m={1}>{this.state.titleDetail}</Box></Typography>
                        <IconButton className={classes.closeButton} onClick={this.handleCloseDetail} size="small">
                         <CloseIcon fontSize="small"/>
                        </IconButton>
                      </DialogTitle>                   
                      <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: !movil ? 'hidden' : 'auto', paddingTop: "0px" }} > 
                      <div className={this.state.loadingDetail && this.state.openModalDetail ? classes.divDetailLoading : classes.divDetail}>
                       {(()=>{
                         
                          if (!this.state.loadingDetail && this.state.openModalDetail) 
                          {                             
                             return (
                                     <React.Fragment>
                                     <Line
                                          data={this.state.chartDetailData}
                                          options={this.state.chartDetailOptions}    
                                          id='chartLine'                            
                                    />
                                    <div style={{ marginTop: 15, textAlign: 'left', display: 'flex', flexDirection: 'row' }}>
                                     <div style={{ background: 'red', border: '#E0E0E0 solid 1px', height: 16, width: 16, marginRight: 8, marginLeft: 35 }}/>{'Parcial sustituído por extra ordinario.'}
                                     </div>
                                    </ React.Fragment>
                                    );
                              
                          }
                          else if (this.state.loadingDetail && this.state.openModalDetail)
                            return(<CircularProgress />);

                        })()
                       }
                      </div>
                      </ DialogContent>                     
                     <DialogActions ref={this.dialogAction2Ref} />
                  </Dialog>                    

                  <Backdrop open={this.state.loadingMain || this.state.loadingPlanes || this.state.loadingClientes || this.state.loadingDetail || this.state.loadingInfo} 
                            className={classes.backdrop} 
                            invisible 
                            transitionDuration={0}/>
                  
      </Paper>
    </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
